import { render } from "./OverlayViewer.vue?vue&type=template&id=f4e20a44"
import script from "./OverlayViewer.vue?vue&type=script&lang=js"
export * from "./OverlayViewer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__